module.exports = {
          srcSet: __webpack_public_path__ + "81d37b682a9d6713df5e79816ecf4cda-1098.png"+" 1098w",
          images:[ {path: __webpack_public_path__ + "81d37b682a9d6713df5e79816ecf4cda-1098.png",width: 1098,height: 1924}],
          src: __webpack_public_path__ + "81d37b682a9d6713df5e79816ecf4cda-1098.png",
          toString:function(){return __webpack_public_path__ + "81d37b682a9d6713df5e79816ecf4cda-1098.png"},
          
          width: 1098,
          height: 1924
        }